// extracted by mini-css-extract-plugin
module.exports = {"term":"KeyTerm_term__d8Z2C","description":"KeyTerm_description__Wv4Bz","container":"KeyTerm_container__ncvsl"};